var map = {
	"./bg1.jpg": "acd6",
	"./bg2.jpg": "f6f4",
	"./bg3.jpg": "7664",
	"./qq.png": "9247",
	"./tip.png": "2be9",
	"./wb.png": "0236",
	"./wx.png": "6a80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf13";